<script>
import RequiredDocument from './RequiredDocument.vue';

export default {
    components: {
        RequiredDocument
    },

    props: {
        defaultRequiredDocuments: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            required: true
        },
        qualificationLevels: {
            type: Array,
            required: true
        },
    },

    data() {
        return {
            requiredDocuments: [...this.defaultRequiredDocuments]
        }
    },

    methods: {
        addRequiredDocument() {
            this.requiredDocuments.push({
                title: '',
                phase: '',
                asnwer_type: '',
                is_trigger: false,
                parent_id: null,
            })
        },
        removeRequiredDocument(index) {
            this.requiredDocuments.splice(index, 1)
        },
    }
}
</script>

<template>
    <div>
        <div v-if="requiredDocuments.length > 0" class="grid-x grid-padding-x mb-2">
            <div class="cell small-5">
                <label>Type:</label>
            </div>

            <div class="cell small-7">
                <label>Title:</label>
            </div>
        </div>

        <required-document
            v-for="(requiredDocument, i) in requiredDocuments"
            :required-document="requiredDocument"
            :index="i"
            :key="i"
            :disabled="disabled"
            @remove="() => removeRequiredDocument(i)"
            :qualification-levels="qualificationLevels"
        />
        
        <div v-if="!disabled" @click="addRequiredDocument" class="add-button"><i class="fas fa-plus-circle"></i></div>

        <input v-if="requiredDocuments.length === 0" name="required_documents" value="" type="hidden" />
    </div>
</template>